import actions from './actions';
import { createReducer } from '../../../../helpers/reducer';

const initState = {
  resolvedList: [],
  outstandingList: [],
  loading: false,
  total: 0,
  filteredTotal: 0,
  sortableColumns: null,
};

function onLoad(state) {
  return {
    ...state,
    loading: true,
  };
}

function onLoadResolvedSuccess(state, { payload }) {
  const { data, total, filteredTotal, sortableColumns } = payload;

  return {
    ...state,
    loading: false,
    resolvedList: data,
    total,
    filteredTotal,
    sortableColumns,
  };
}

function onLoadOutstandingSuccess(state, { payload }) {
  const { data, total, filteredTotal, sortableColumns } = payload;

  return {
    ...state,
    loading: false,
    outstandingList: data,
    total,
    filteredTotal,
    sortableColumns,
  };
}

function onClearStore() {
  return { ...initState };
}

export default createReducer(initState, {
  [actions.LOAD_RESOLVED]: onLoad,
  [actions.LOAD_OUTSTANDING]: onLoad,
  [actions.LOAD_RESOLVED_SUCCESS]: onLoadResolvedSuccess,
  [actions.LOAD_OUTSTANDING_SUCCESS]: onLoadOutstandingSuccess,
  [actions.CLEAR_STORE]: onClearStore,
});
